import axios from 'axios';
import { JsonResponse } from 'core/models/response';

import { RaiseCapitalListResponse, RaiseCapitalOtpKey } from '../models/raiseCapitals';
import { ProfitCapitalization } from '../models/profitCapitalization';
import { TreasurySharesAcquisition } from '../models/treasurySharesAcquisition';
import { PrivateEquityIssuance } from '../models/privateEquityIssuance';

export const onGetRaiseCapitalsList = async (page: number = 1) => {
	try {
		const response = await axios.get<JsonResponse<RaiseCapitalListResponse>>('dashboard/actions/raise-capital', {
			params: { page },
		});
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onGetRaiseCapital = async (id: number, page: number = 1) => {
	try {
		const response = await axios.get<JsonResponse<ProfitCapitalization | TreasurySharesAcquisition | PrivateEquityIssuance>>(
			`dashboard/actions/raise-capital/${id}`,
			{
				params: { page },
			},
		);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onSendCapitalRaiseOtp = async (type: RaiseCapitalOtpKey) => {
	try {
		const response = await axios.post<JsonResponse<{ ttl: number }>>('dashboard/actions/raise-capital/send-otp', { type });
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onCancelCapitalRaise = async (id: number) => {
	try {
		const response = await axios.put(`dashboard/actions/raise-capital/${id}/cancel`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};
